<script>
import 'veui/locale/zh-Hans/common.js'
import 'veui/locale/en-US/common.js'

import FaIcon from 'vue-awesome/components/Icon'
import { prefixify } from '../mixins/prefix'

export default {
  ...FaIcon,
  name: 'veui-icon',
  mixins: [
    {
      data () {
        return {
          classes: {
            [prefixify('icon')]: true
          }
        }
      }
    }
  ]
}
</script>
<style lang="less" src="veui-theme-dls/components/icon.less"></style>
